import React from "react";

const ExpenseList = ({ expenses, onDelete }) => {
  if (expenses.length === 0) return <p>No expenses found.</p>;

  return (
    <ul className="expense-list">
      {expenses.map((exp) => (
        <li key={exp.id}>
          <div>
            <strong>{exp.title}</strong> - ${exp.amount.toFixed(2)} on {exp.date} [{exp.category}]
          </div>
          <button onClick={() => onDelete(exp.id)}>❌</button>
        </li>
      ))}
    </ul>
  );
};

export default ExpenseList;
